export const version = '1.0.0';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const themeVariants = ['light', 'dark', 'auto'];

// API Configuration
const config = {
  // URL base de la API
  // Fallback = hostname nativo de ACA (el viejo galaxy-api.herrerahavas.com quedó
  // muerto tras el secuestro del dominio .com; la app vive en *.herrerahavas.com.ec).
  apiUrl: process.env.REACT_APP_API_URL || 'https://galaxy-backend.grayrock-48a77db7.southcentralus.azurecontainerapps.io/api',
  
  // Configuración de autenticación
  auth: {
    tokenKey: 'galaxy_metrics_token',
    refreshTokenKey: 'galaxy_metrics_refresh_token',
    userKey: 'galaxy_metrics_user',
  },
  
  // Configuración de la aplicación
  app: {
    name: 'Galaxy Metrics',
    version: '1.0.0',
    environment: process.env.NODE_ENV || 'production',
  },
  
  // URLs de desarrollo (fallback)
  development: {
    apiUrl: 'http://localhost:3001/api',
  }
};

export const settings = {
  isFluid: true,
  isRTL: false,
  isDark: false,
  theme: 'light',
  navbarPosition: 'vertical',
  showBurgerMenu: false, // controls showing vertical nav on mobile
  currency: '$',
  isNavbarVerticalCollapsed: false, // toggle vertical navbar collapse
  navbarStyle: 'card'
};

const defaultConfig = { version, navbarBreakPoint, topNavbarBreakpoint, settings, config };
export default defaultConfig;
